(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.grassroots = svs.grassroots || svs.grassroots_shared || {};
svs.grassroots.app = new Marionette.Application({
  region: '#grassroots',
  onStart: function() {
    svs.grassroots_logger = new svs.core.log.Logger('module:grassroots');

    svs.grassroots.app.mainView = svs.grassroots.app.getRegion();
    svs.game_results_logger = new svs.core.log.Logger('module:game-results');
    svs.grassroots.router = new svs.grassroots.Router();
    Backbone.History.started ||
      Backbone.history.start({
        pushState: true,
        root: svs.core.data.baseUrl,
        hashChange: false
      });
  }
});

svs.grassroots.common = svs.grassroots.common || {};
svs.grassroots.collections = svs.grassroots.collections || {};
svs.grassroots.views = svs.grassroots.views || {};
svs.grassroots.models = svs.grassroots.models || {};
svs.grassroots.router = svs.grassroots.router || {};
svs.grassroots.helpers = svs.grassroots.helpers || {};
svs.grassroots.helpers.dialog = svs.grassroots.helpers.dialog || {};



 })(window);